import { createQuery } from 'react-query-kit';

import * as ProjectTypes from '../api/project/types.api';
import * as ProjectAPI from '../api/project/index.api';

//
//

const key = 'projects';

//

export const useQueryProjectGet = createQuery<
  ProjectTypes.ProjectResponse,
  ProjectTypes.ProjectQuery
>({
  queryKey: [key],
  fetcher: (params, options) => ProjectAPI.getProjectByCodeAPI(params),
});
